import { post } from "../api.helper/root";
import tokenService from "../token.service";

import {
  ForgotPasswordPayload,
  LoginPayload,
  LogoutPayload,
  MfaLoginPayload,
  RefreshTokenPayload,
  ResetPasswordPayload,
  VerifyUserLoginPayload
} from "@/types/auth";

const authUri = process.env.VUE_APP_AUTH_BASE_URL as string;

const loginUri = `${authUri}/userlogin`;
const forgotPasswordUri = `${authUri}/forgotpassword`;
const resetPasswordUri = `${authUri}/resetpassword`;
const logoutUri = `${authUri}/userlogout`;
const mfaLoginUri = `${authUri}/userlogin/authresponse`;
const refreshTokenUri = `${authUri}/refreshtoken`;
const verifyUserLoginUri = `${authUri}/userlogin/verify`;

export const login = (userData: LoginPayload) => post(loginUri, userData);

export const forgotPassword = (userData: ForgotPasswordPayload) => post(forgotPasswordUri, userData);

export const resetPassword = (userData: ResetPasswordPayload) => post(resetPasswordUri, userData);

export const logout = (userData: LogoutPayload) => post(logoutUri, userData);

export const mfaLogin = (userData: MfaLoginPayload) => post(mfaLoginUri, userData);

export const verifyUserLogin = (userData: VerifyUserLoginPayload) => post(verifyUserLoginUri, userData);

export const refreshToken = (userData: RefreshTokenPayload) => 
  post(
    refreshTokenUri,
    userData, 
    {
      headers: { refreshToken: tokenService.getRefreshToken() as string }
    }
  );
